import axios from 'axios';
import API_ROUTES from '../../routes/ApiRoutes.js';

/**  Obtiene la matriz de horas Los filtros son opcionales */
export const getHoursMatrix = async ({ resourceTypeId, multimediaLevelId, instructionalLevelId } = {}) => {
    const params = {};

    if (resourceTypeId) params.resourceTypeId = resourceTypeId;
    if (multimediaLevelId) params.multimediaLevelId = multimediaLevelId;
    if (instructionalLevelId) params.instructionalLevelId = instructionalLevelId;

    const { data } = await axios.get( API_ROUTES.HOURS_MATRIX, { params } );

    return data;
};

/** Actualiza solo las horas hombre */
export const updateHoursMatrix = async (id, hours_man) => {
    const { data } = await axios.patch( `${API_ROUTES.HOURS_MATRIX}/${id}`, { hours_man } );

    return data;
};